import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { client } from '@Utils'
import { Pagination } from '@CommonComponents/buttons'
import { usePageRequest } from '@CommonComponents'

export const App = ({ userId }) => {
  const [currentLogs, setCurrentLogs] = useState([])
  const [paginationRate, setPaginationRate] = useState(20)
  const [totalLogs, setTotalLogs] = useState(0)
  const [noLogs, setNoLogs] = useState(false)
  const {
    page: currentPage,
    attempt: pageAttempt,
    request: changePage,
    settle: settlePage,
  } = usePageRequest()
  const failureMessage = useRef(null)

  useEffect(() => {
    // A later page replaces this load, so its response is dropped.
    let cancelled = false
    const fetchLogs = async () => {
      try {
        let resp = await client.get(
          `/account/support_dashboard.get_lti13_logs/-/${userId}?page_num=${currentPage}&page_rate=${paginationRate}`
        )
        if (cancelled) return
        setPaginationRate(resp.data.pagRate)
        setTotalLogs(resp.data.total)
        setCurrentLogs(resp.data.logs)
        settlePage()
      } catch (err) {
        if (cancelled) return
        // The failure branch below unmounts both pagers.
        settlePage(err)
        console.error(err.message)
        setNoLogs(true)
      }
    }
    fetchLogs()
    return () => {
      cancelled = true
    }
  }, [pageAttempt])

  const pages = Math.ceil(totalLogs / paginationRate)

  return (
    <div>
      {noLogs ? (
        <h4 className="text-center" ref={failureMessage} tabIndex={-1}>
          There are no logs to display or there was an error trying to fetch
          them.
        </h4>
      ) : (
        <React.Fragment>
          {pages > 1 && (
            <Pagination
              label="Pagination, top"
              currentPage={currentPage}
              setCurrentPage={changePage}
              rate={paginationRate}
              total={totalLogs}
              failureMessage={failureMessage}
            />
          )}
          <table className="table table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th>Launch Time (UTC)</th>
                <th>Log ID</th>
                <th>View</th>
              </tr>
            </thead>
            <tbody>
              {currentLogs.map(log => (
                <tr key={`${log.id}`}>
                  <td>{log.time}</td>
                  <td>{log.id}</td>
                  <td>
                    <a
                      href={log.href ? log.href : ''}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <Button className="btn btn-myed btn-default btn-default-myed btn-sm-myed">
                        View <i className="fa-light fa-external-link ml-2" />
                      </Button>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {pages > 1 && (
            <Pagination
              label="Pagination, bottom"
              currentPage={currentPage}
              setCurrentPage={changePage}
              rate={paginationRate}
              total={totalLogs}
              failureMessage={failureMessage}
            />
          )}
        </React.Fragment>
      )}
    </div>
  )
}

App.propTypes = {
  userId: PropTypes.string,
}
